<template>
  <card id="markdown-preview">
    <v-wait :for="waiterKeyword">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <mk-docs-material :html="html"></mk-docs-material>
    </v-wait>
  </card>
</template>

<script>

  import miscEndpoints from "../../api/misc";
  import Spinner from 'vue-spinner-component/src/Spinner';
  import MkDocsMaterial from "../MkDocs/MkDocsMaterial";
  import {tryExceptAwait} from "../../utils";

  export default {
    name: "MarkdownPreview",
    data() {
      return {
        html: "",
        showButton: true,
        waiterKeyword: 'preview loading'
      }
    },
    components: {
      MkDocsMaterial,
      Spinner: Spinner
    },

    props: {
      value: String
    },

    methods: {
      async getPreview() {
        this.$wait.start(this.waiterKeyword);
        const response = await tryExceptAwait(
          miscEndpoints.renderMarkdown,
          [{body: this.value}]
        )
        if (response.data && response.data.html) {
          this.html = response.data.html
        }
        this.$wait.end(this.waiterKeyword);
      }
    }
  }
</script>
<style scoped lang="scss">
  #markdown-preview {
    max-height: 690px;
    overflow: auto;
    border: 1px solid #e4e7ec;
  }
</style>
